import React, { Component } from 'react';
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner, Modal } from "react-bootstrap";
import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import SelectDropDown from '../selectdropdown/SelectDropDown';
import MultiSelect from "react-multi-select-component";
import BreadcrumbCustomQuestionTwo from '../breadcrumbs/BreadcrumbCustomQuestionTwo';
import { components } from 'react-select'
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import DateTime from 'react-datetime';
import '../../../react-datetime.css';

const DropdownIndicator = (props) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};


const FETCH_GLOBALS = gql` 
query($institution_id: Int!) {
    globals(institution_id: $institution_id){
      b_e_c_s_data {
        section_id
        class_id
        branch_id
        exam_id
      }
        exams{
            id
            exam
            exam_subjects{
                subject_id
            }
        }
        globalBranches{
            id
            exam_id
            branch_name
        }
        classes{
            id
            class
        }
        globalSections{
            id
            section_name
            exam_id
            branch_id
            category_id
        }
        subjects{
            id
            subject
            chapters{
                id
                chapter
                topics{
                    id
                    topic
                    # practice_percentage
                }
                class
            }
        }
        questionTypes{
            id
            questiontype
        }
        questionTheory{
            id
            question_theory
        }

   instituteExamPapers{
     id
     exampaper
     exam_type
     pexamtype
   }
    }
}
`;

const FETCH_SECTIONS = gql` 
query($institution_id: Int!) {
    getSections(institution_id: $institution_id){
        id
        section_name
        branch_id
    }
}
`;

const FETCH_PDF_FILES_DATA = gql`
  query GetAIMLFiles($exams: [String]) {
    getAIMLFiles(exams: $exams) {
      id
      file_name
    }
  }
`;

const COLLEGE_AIML_PDF_PAPER = gql`
  mutation(
    $params:GenerateInstituteExamPdfInput  
    ) {
        createInstituteExamPaperFromPdf(
        params: $params
     ){
         id
         filename
     }
  }
`;

class CreateExamPaperPdf extends Component {

    constructor(props) {
        super(props);
        this.state = {
            enterExamName: "",
            selectedExam: "",
            selectedExamType: "",
            selectedClass: "",
            selectSection: "",
            selectedSectionValue: [],
            selectedStartDate: moment(),
            selectedEndDate: moment().add(3, 'hours'),
            selectedPattern: "",
            BreadcrumbCustomQuestionsSection: {
                img: require('../../../images/Neet-Exam.png'),
                Title: 'Create Exam Paper',
                SubTitle: 'Create Exam Paper',
                ClassSectionTotalStudents: "",
                complexity: "",
                subjects: ""
            },
            pdfFilesOptions: [],
            selectedPdfFile: "",
            formErrors: {},
            branchSelected: "",
            isLoading: false
        };
    };

    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    getexamType() {
        let getArray = [];
        const globalsData = this.props.globals.globals;
        if (!globalsData || !globalsData.exams) return getArray;

        for (let i = 0; i < globalsData.exams.length; i++) {
            let idata = globalsData.exams[i];
            if (idata != undefined) {
                if (idata.id != "5") {
                    const newObj = {
                        value: idata.id,
                        label: idata.exam
                    }
                    getArray.push(newObj);
                }
            }
        }
        return getArray;
    }

    selecthandleInputChange = (ename, evalue, option) => {
        console.log("selecthandleInputChange", ename, evalue, option);
        if (ename == "examtype") {
            const globalsData = this.props.globals.globals;
            if (globalsData && globalsData.exams) {
                let examsData = globalsData.exams.find((a) => a.id == evalue);
                if (examsData) {
                    this.setState({
                        selectedExam: { value: examsData.id, label: examsData.exam },
                        selectedPdfFile: "", // Reset selected file on exam change
                    });

                    // Fetch PDF files for the selected exam
                    this.props.client.query({
                        query: FETCH_PDF_FILES_DATA,
                        variables: { exams: [examsData.exam] },
                        fetchPolicy: 'network-only'
                    }).then(res => {
                        const pdfData = res.data.getAIMLFiles || [];
                        const pdfOptions = pdfData.map(file => ({
                            label: file.file_name,
                            value: file.id
                        }));
                        this.setState({ pdfFilesOptions: pdfOptions });
                    }).catch(err => {
                        console.error("Error fetching PDF files", err);
                    });
                }
            }
        } else if (ename == "selectedExamType") {
            this.setState({
                selectedExamType: option,
            });
        } else if (ename == "pdfFile") {
            this.setState({
                selectedPdfFile: option,
            });
        } else if (ename == "class") {
            this.setState({
                selectedClass: option
            });
        }
    };

    handlePatternChange = (e) => {
        console.log("handlePatternChange", e.target.value);
        this.setState({
            selectedPattern: e.target.value,
        });
    };

    getClassData = () => {
        const { globals } = this.props;
        const globalsData = globals.globals;

        const examId = this.state?.selectedExam?.value;
        if (!examId || !globalsData) return [];

        const uniqueClassIds = new Set(
            globalsData.b_e_c_s_data
                .filter((item) => +item.exam_id === +examId)
                .map((item) => item.class_id)
        );

        // 👉 Map class_ids to { value, label }
        const classArray = [...uniqueClassIds].reduce((acc, id) => {
            const classObj = globalsData.classes.find((cls) => cls.id === id);
            if (classObj) {
                acc.push({
                    value: classObj.id,
                    label: classObj.class,
                });
            }
            return acc;
        }, []);

        return classArray;
    };

    getSectionData = () => {
        const { globals } = this.props;
        const globalsData = globals.globals;

        const examId = +this.state?.selectedExam?.value;
        const classId = +this.state?.selectedClass?.value;

        if (!examId || !classId || !globalsData) return [];

        // 👉 Step 1: Unique section IDs
        const uniqueSectionIds = new Set(
            globalsData.b_e_c_s_data
                .filter(
                    (item) =>
                        +item.exam_id === +examId &&
                        +item.class_id === +classId
                )
                .map((item) => item.section_id)
        );
        // 👉 Step 2: Convert to label/value array
        const sectionArray = [...uniqueSectionIds].reduce((acc, id) => {
            const sectionObj = globalsData.globalSections.find((s) => s.id == id);
            if (sectionObj) {
                acc.push({
                    value: sectionObj.id,
                    label: sectionObj.section_name,
                    branch: sectionObj.branch_id
                });
            }
            return acc;
        }, []);

        return sectionArray;
    };

    sectionhandleMultipleSelectInputChange = (e) => {
        console.log("sectionhandleMultipleSelectInputChange", e);
        const branch = e.map(i => i.branch);
        this.setState({
            selectedSectionValue: e,
            branchSelected: branch
        });
    }

    handleSubmit = () => {
        const {
            enterExamName,
            selectedExam,
            selectedExamType,
            selectedPattern,
            selectedPdfFile,
            selectedClass,
            selectedSectionValue
        } = this.state;

        let errors = {};
        if (!enterExamName || enterExamName.trim() === "") errors.enterExamName = "Exam Name is required";
        if (!selectedExam) errors.selectedExam = "Exam is required";

        if (selectedExam && selectedExam.value == "2") {
            if (!selectedExamType) errors.selectedExamType = "Exam Type is required";
            if (selectedExamType && selectedExamType.value == "2" && !selectedPattern) {
                errors.selectedPattern = "Pattern is required";
            }
        }

        if (!selectedPdfFile) errors.selectedPdfFile = "PDF File is required";
        if (!selectedClass) errors.selectedClass = "Class is required";
        if (!selectedSectionValue || selectedSectionValue.length === 0) errors.selectedSectionValue = "Section is required";

        this.setState({ formErrors: errors });

        if (Object.keys(errors).length > 0) {
            return;
        }

        this.setState({ isLoading: true });


        let examtypema = "";
        if (this.state.selectedExamType.value == "2") {
            examtypema = this.state.selectedPattern;
        } else {
            examtypema = "0";
        }

        let creategeneralpaper = "";

        let selectedStartDate = "";
        if (this.state.selectedStartDate == "") {
            selectedStartDate = moment().format("DD-MM-YYYY HH:mm:ss");
        } else {
            selectedStartDate = this.state.selectedStartDate;
        }

        let selectedEndDate = "";
        if (this.state.selectedEndDate == "") {
            selectedEndDate = moment().format("DD-MM-YYYY HH:mm:ss");
        } else {
            selectedEndDate = this.state.selectedEndDate;
        }

        let branchArr = [];
        let sectionsArr = [];

        const sectionData = this.getSectionData() || [];

        const hasNonZero = this.state.branchSelected?.some(v => v !== 0);

        let branchValues = [];
        let sectionValues = [];

        if (hasNonZero) {
            branchValues = this.state.branchSelected.map(Number);
            sectionValues = this.state.selectedSectionValue.map((item) => item.value);
        } else {
            branchValues = sectionData.map((item) => item.branch);
            sectionValues = sectionData.map((item) => item.value);
        }

        let branches = [...new Set(branchValues)]
        for (let i = 0; i < branches.length; i++) {
            branchArr.push(parseInt(branchValues[i]));
        }


        for (let i = 0; i < sectionValues.length; i++) {
            sectionsArr.push(parseInt(sectionValues[i]));
        }

        creategeneralpaper = {
            exam_name: this.state.enterExamName,
            pdf_file: this.state.selectedPdfFile.label,
            previous_set_id: parseInt(this.state.selectedPdfFile.value),
            exam_type: parseInt(this.state.selectedExamType.value),
            class_id: parseInt(this.state.selectedClass.value),
            branch: branchArr.toString(),
            section: sectionsArr.toString(),
            sub_exam_type: parseInt(examtypema),
            no_of_sets: 1,
            start_time: moment(selectedStartDate).format("MMM DD YYYY HH:mm:ss"),
            end_time: moment(selectedEndDate).format("MMM DD YYYY HH:mm:ss"),
            institution_id: parseInt(Cookies.get("institutionid")),
            username: Cookies.get("username"),
            mains_2021: true,
            exam_pattern_id: this.state.selectedExamType?.value === "1" ? 4 : this.state.selectedExamType?.value === "1" ? 63 : this.state.selectedPattern,
        };

        console.log("creategeneralpaper", creategeneralpaper);

        this.createInstitutepaperfrompdf(
            creategeneralpaper
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError1: error.graphQLErrors ? error.graphQLErrors.map(x => x.message) : [error.message], spinnerStatus: "",
                isLoading: false
            });
            console.error("ERR =>", error.graphQLErrors ? error.graphQLErrors.map(x => x.message) : error.message);
        });
    };

    createInstitutepaperfrompdf = async (
        params) => {
        await this.props.createInstitutepaperfrompdf({
            variables: {
                params
            },
            update: (store, { data }) => {
                console.log("createGeneralPaperdata", data);
                if (data.createInstituteExamPaperFromPdf) {
                    if (this.props.data && typeof this.props.data.refetch === 'function') {
                        this.props.data.refetch();
                    }
                    this.props.globals.refetch();
                    setTimeout(() => {
                        this.setState({
                            spinnerStatus: "",
                            submitError1: "",
                            isLoading: false
                        });
                        this.props.history.push("/settings/exam-paper-pdf/upload");
                    }, 3000);
                }
            }
        }).then((res) => {
            console.log("success", res);
            // this.props.data.refetch();
            setTimeout(() => {
                this.setState({
                    modalShow: false,
                    spinnerStatus: "",
                    submitError1: "",
                    isLoading: false
                });
                this.props.history.push("/settings/exam-paper-pdf/upload");
            }, 3000);
        });
    };


    handleStartDateChange = (selectedMoment) => {
        const date = moment(selectedMoment);

        const add3Hours = date.clone().add(3, 'hours');

        this.setState({
            selectedStartDate: date,
            selectedEndDate: add3Hours,
        });
    };

    // ✅ When end date changes
    handleEndDateChange = (selectedMoment) => {
        const date = moment(selectedMoment);

        // Prevent selecting time before start
        if (date.isBefore(this.state.selectedStartDate)) {
            alert("⚠️ End time cannot be before start time!");
            return;
        }

        this.setState({ selectedEndDate: date });
    };

    validStartDate = (current) => {
        const today = moment().startOf("day");
        return current.isSameOrAfter(today, "day");
    };

    // ✅ Allow only the same calendar day
    validEndDate = (current) => {
        const { selectedStartDate } = this.state;
        if (!selectedStartDate) return true;
        return current.isSame(selectedStartDate, "day");
    };

    // ✅ Prevent selecting time before start time (same day)
    validEndTime = (current) => {
        const { selectedStartDate } = this.state;
        if (!selectedStartDate) return true;

        // Same day → disallow earlier times
        if (current.isSame(selectedStartDate, "day")) {
            return current.isAfter(selectedStartDate);
        }
        return false;
    };


    render() {
        const globals = this.props.globals;
        const loading3 = globals.loading;
        const error3 = globals.error;

        const getSectionsProp = this.props.getSections;
        const loading1 = getSectionsProp.loading;
        const error1 = getSectionsProp.error;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }
        if (error3 !== undefined) {
            alert("Server Error. " + error3.message);
            return null;
        }

        if (loading1 || loading3) {
            return (
                <div style={{ textAlign: "center", padding: 60 }}>
                    <Spinner animation="border" variant="primary" />
                    <p style={{ marginTop: 10 }}>Loading...</p>
                </div>
            );
        }

        const examtypema = [
            { value: "1", label: "MAINS" },
            { value: "2", label: "ADVANCE" }
        ];

        let sectionselectall = true;
        let sectionlabelledBy = "Select";
        let sectiondisableSearch = false;

        const sectionsData = getSectionsProp.getSections || [];

        if (sectionsData.length > 0) {
            sectionselectall = true;
            sectiondisableSearch = false;
        }
        else {
            sectiondisableSearch = true;
            sectionselectall = false;
            sectionlabelledBy = "Sections"
        }

        console.log("render", this.state);


        return (
            <div>
                <ToastContainer />
                <Row>
                    <Col xl={9} lg={9} md={12} sm={12}>
                        <div className="">
                            <BreadcrumbCustomQuestionTwo breadcrumbs={this.state.BreadcrumbCustomQuestionsSection} />
                        </div>

                        <Card as={Card.Body} className="border-0 shadow-sm">
                            <Row className="align-items-top">
                                <Col lg={6} md={12} sm={12}>
                                    <Form.Group controlId="formCategory">
                                        <Form.Label>Exam Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="enterExamName"
                                            value={this.state.enterExamName}
                                            onChange={this.handleInputChange}
                                            placeholder="Enter Exam Name"
                                            autoComplete="off"
                                        />
                                        {this.state.formErrors?.enterExamName && <span className="text-danger" style={{ fontSize: "12px" }}>{this.state.formErrors.enterExamName}</span>}
                                    </Form.Group>
                                </Col>

                                <Col lg={6} md={12} sm={12}>
                                    <Form.Group controlId="formCategory">
                                        <Form.Label>Exam</Form.Label>
                                        <SelectDropDown
                                            stateData={this.state.selectedExam}
                                            handleChange={this.selecthandleInputChange}
                                            name="examtype"
                                            options={this.getexamType()}
                                            placeholderName={'Exam Type'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                            isClearable={false}
                                        />
                                        {this.state.formErrors?.selectedExam && <span className="text-danger" style={{ fontSize: "12px" }}>{this.state.formErrors.selectedExam}</span>}
                                    </Form.Group>
                                </Col>


                                {this.state.selectedExam?.value == "2" ? (
                                    <React.Fragment>
                                        <Col lg={6} md={12} sm={12}>
                                            <Form.Group controlId="formCategory">
                                                <Form.Label>Select Exam Type</Form.Label>
                                                <SelectDropDown
                                                    stateData={this.state.selectedExamType}
                                                    handleChange={this.selecthandleInputChange}
                                                    name="selectedExamType"
                                                    options={examtypema}
                                                    placeholderName={'Exam Type'}
                                                    dropdownIndicator={{ DropdownIndicator }}
                                                    isClearable={false}
                                                />
                                            </Form.Group>
                                        </Col>


                                        {
                                            this.state.selectedExamType?.value == "1" ? (
                                                <Col lg={3} md={12} sm={12}>
                                                    <Form.Label>Pattern</Form.Label>
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            id="customCheck"
                                                            name="mains_2021"
                                                            className="custom-control-input"
                                                            checked
                                                            disabled
                                                        />
                                                        <label className="custom-control-label" htmlFor="customCheck">
                                                            NTA PATTERN
                                                        </label>
                                                    </div>
                                                </Col>
                                            ) : (
                                                <Col lg={3} md={12} sm={12}>
                                                    <Form.Label>Pattern</Form.Label>
                                                    <div className="custom-control custom-radio">
                                                        {[
                                                            { value: 78, label: "Pattern 1", tooltip: "JEE Advanced 2024 paper 1" },
                                                            { value: 79, label: "Pattern 2", tooltip: "JEE Advanced 2024 paper 2" },
                                                        ].map((item, index) => (
                                                            <div key={index} className="custom-control custom-radio mb-2">
                                                                <input
                                                                    type="radio"
                                                                    className="custom-control-input"
                                                                    id={`customRadio-${item.value}`}
                                                                    name="patternGroup"
                                                                    value={item.value}
                                                                    checked={+this.state.selectedPattern === +item.value}
                                                                    onChange={this.handlePatternChange}
                                                                    title={item.tooltip}   // <-- tooltip on input
                                                                />
                                                                <label
                                                                    className="custom-control-label"
                                                                    htmlFor={`customRadio-${item.value}`}
                                                                    title={item.tooltip}   // <-- tooltip on label
                                                                >
                                                                    {item.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                        {this.state.formErrors?.selectedPattern && <span className="text-danger" style={{ fontSize: "12px" }}>{this.state.formErrors.selectedPattern}</span>}
                                                    </div>
                                                </Col>
                                            )
                                        }
                                    </React.Fragment>
                                ) : ""}

                                <Col lg={6} md={12} sm={12}>
                                    <Form.Group controlId="formPdfFiles" style={{ zIndex: 10 }}>
                                        <Form.Label>PDF File</Form.Label>
                                        <SelectDropDown
                                            stateData={this.state.selectedPdfFile}
                                            handleChange={this.selecthandleInputChange}
                                            name="pdfFile"
                                            options={this.state.pdfFilesOptions}
                                            placeholderName={'Select PDF File'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                            isDisabled={this.state.pdfFilesOptions.length === 0}
                                            isClearable={false}
                                        />
                                        {this.state.formErrors?.selectedPdfFile && <span className="text-danger" style={{ fontSize: "12px" }}>{this.state.formErrors.selectedPdfFile}</span>}
                                    </Form.Group>
                                </Col>

                                <Col lg={6} md={12} sm={12}>
                                    <Form.Group controlId="formCategory">
                                        <Form.Label>Class</Form.Label>
                                        <SelectDropDown
                                            stateData={this.state.selectedClass}
                                            handleChange={this.selecthandleInputChange}
                                            name="class"
                                            options={this.getClassData()}
                                            placeholderName={'Class'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />
                                        {this.state.formErrors?.selectedClass && <span className="text-danger" style={{ fontSize: "12px" }}>{this.state.formErrors.selectedClass}</span>}
                                    </Form.Group>
                                </Col>

                                <Col lg={6} md={12} sm={12}>
                                    <Form.Label>Section</Form.Label>
                                    <MultiSelect
                                        overrideStrings={{
                                            allItemsAreSelected: "All Sections are selected.",
                                            selectSomeItems: sectionlabelledBy
                                        }}
                                        disableSearch={sectiondisableSearch}
                                        hasSelectAll={sectionselectall}
                                        placeholderName="Section"
                                        options={this.getSectionData()}
                                        value={this.state.selectedSectionValue}
                                        onChange={(e) => this.sectionhandleMultipleSelectInputChange(e)}
                                        labelledBy="Section"
                                    />
                                    {this.state.formErrors?.selectedSectionValue && <span className="text-danger" style={{ fontSize: "12px" }}>{this.state.formErrors.selectedSectionValue}</span>}
                                </Col>


                                <Col lg={6} md={12} sm={12}>
                                    <Form.Label>Start Date</Form.Label>
                                    <DateTime
                                        value={this.state.selectedStartDate}
                                        name="startdate"
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat="hh:mm A"
                                        inputProps={{ placeholder: "Start Date" }}
                                        onChange={this.handleStartDateChange}
                                        isValidDate={this.validStartDate}
                                    />
                                </Col>

                                <Col lg={6} md={12} sm={12} className='mt-2'>
                                    <Form.Label>End Date</Form.Label>
                                    <DateTime
                                        value={this.state.selectedEndDate}
                                        name="enddate"
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat="hh:mm A"
                                        inputProps={{ placeholder: "End Date" }}
                                        onChange={this.handleEndDateChange}
                                        isValidDate={this.validEndDate}
                                        isValidTime={this.validEndTime}
                                    />
                                </Col>
                            </Row>
                        </Card>
                    </Col>

                    <Col xl={3} lg={3} md={12} sm={12}>
                        <Card className="aside border-0 shadow-sm">
                            <Card.Header className="border-0 bg-light text-center">
                                <h6 className="mb-0 text-primary font-weight-bold">EXAM PAPER DETAILS</h6>
                            </Card.Header>
                            <Card.Body className="p-3">
                                <Table className="table-borderless table-sm mb-0">
                                    <tbody>
                                        <tr>
                                            <th className="text-muted" style={{ width: "45%" }}>Exam Name</th>
                                            <th className="text-dark">: {this.state.enterExamName || "-"}</th>
                                        </tr>
                                        <tr>
                                            <th className="text-muted">PDF Name</th>
                                            <th className="text-dark">: {this.state.selectedPdfFile ? this.state.selectedPdfFile.label : "-"}</th>
                                        </tr>
                                        <tr>
                                            <th className="text-muted">Class</th>
                                            <th className="text-dark">: {this.state.selectedClass ? this.state.selectedClass.label : "-"}</th>
                                        </tr>
                                        <tr>
                                            <th className="text-muted">Section(s)</th>
                                            <th className="text-dark">: {this.state.selectedSectionValue && this.state.selectedSectionValue.length > 0 ? this.state.selectedSectionValue.map(s => s.label).join(", ") : "-"}</th>
                                        </tr>
                                        <tr>
                                            <th className="text-muted">Exam</th>
                                            <th className="text-dark">: {this.state.selectedExam ? this.state.selectedExam.label : "-"} </th>
                                        </tr>
                                        {this.state.selectedExam && this.state.selectedExam.value ? (
                                            <React.Fragment>
                                                {this.state.selectedExam.value == "1" ? (
                                                    <React.Fragment>
                                                        <tr>
                                                            <th className="text-muted">Duration</th>
                                                            <th className="text-dark">: 180 min </th>
                                                        </tr>
                                                        <tr>
                                                            <th className="text-muted">Questions</th>
                                                            <th className="text-dark">: 180</th>
                                                        </tr>
                                                    </React.Fragment>
                                                ) : (
                                                    <React.Fragment>
                                                        {this.state.selectedExamType && this.state.selectedExamType.value == "1" ? (
                                                            <React.Fragment>
                                                                <tr>
                                                                    <th className="text-muted">Duration</th>
                                                                    <th className="text-dark">: 180 min </th>
                                                                </tr>
                                                                <tr>
                                                                    <th className="text-muted">Questions</th>
                                                                    <th className="text-dark">: 75</th>
                                                                </tr>
                                                            </React.Fragment>) : (
                                                            <React.Fragment>
                                                                <tr>
                                                                    <th className="text-muted">Duration</th>
                                                                    <th className="text-dark">: 300 min </th>
                                                                </tr>
                                                                <tr>
                                                                    <th className="text-muted">Questions</th>
                                                                    <th className="text-dark">: 75</th>
                                                                </tr>
                                                            </React.Fragment>)}

                                                    </React.Fragment>
                                                )}
                                            </React.Fragment>
                                        ) : null}
                                    </tbody>
                                </Table>
                            </Card.Body>
                            <Card.Footer className="border-0 bg-white p-3">
                                <Button
                                    variant="primary"
                                    block
                                    className="w-100 text-uppercase font-weight-bold"
                                    onClick={this.handleSubmit}
                                    disabled={this.state.isLoading}
                                >
                                    {this.state.isLoading ? (
                                        <>
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                className="mr-2"
                                            />
                                            Generating...
                                        </>
                                    ) : (
                                        "Save & Generate"
                                    )}
                                </Button>
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}
export default withRouter(
    compose(
        withApollo,
        graphql(FETCH_GLOBALS,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))
                    },
                    fetchPolicy: 'cache-and-network'
                }), name: "globals"
            }),
        graphql(FETCH_SECTIONS,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))
                    },
                    fetchPolicy: 'cache-and-network'
                }), name: "getSections"
            }),
        graphql(COLLEGE_AIML_PDF_PAPER, {
            name: "createInstitutepaperfrompdf"
        }),
    )
        (CreateExamPaperPdf));